import { HttpClient, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, finalize, map, takeLast } from "rxjs";
import { environment } from "src/environments/environment";
import { Intervention } from "../domain/intervention";
import { CoreData } from "../tools/core-data/core-data";
import { LoadingTask } from "../tools/ui/loading-task";
import { BaseService } from "./base-service";
import { InterventionDTO } from "./dto/intervention.dto";
import { MatSnackBar } from "@angular/material/snack-bar";
import { json } from "stream/consumers";
import { MeasureMassif } from "../domain/Massif/measure-massif";
import { AreaMap } from "../domain/area-map";
import { Zone } from "../domain/zone";
import { Process } from "../domain/process";

@Injectable({
    providedIn: 'root',
})
export class InterventionService extends BaseService {

    private serviceUrl = `${environment.serviceBaseUrl}api/intervention`;

    constructor(public http: HttpClient,
        protected override coreData: CoreData,
        protected snackBare: MatSnackBar,
        private loadingTask: LoadingTask,
        protected override router: Router) {

        super(router, coreData, snackBare);
    }

    getMyIntervention() {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/my/active`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getMyIntervention')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: InterventionDTO[]) => {
                return response.map((item: InterventionDTO) => {
                    return Intervention.mapFromJSON(item);
                });
            }));
    }

    geInterventionByCode(interventionCode: number) {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/${interventionCode}`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('geInterventionByCode')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: InterventionDTO) => {
                return Intervention.mapFromJSON(response);
            }));
    }

    syncIntervention(int: Intervention) {
        this.loadingTask.activateLoading();

        let dto = Object.assign({}, int);
        dto.LingetteAreaMapTerrainList.forEach((areaMap: AreaMap) => {
            delete areaMap.BackgroundPicture;
        });

        dto.ZoneList.forEach((item: Zone) => {
            item.AreaMapList.forEach((areaMap: AreaMap) => {
                delete areaMap.BackgroundPicture;
            });
        });

        dto.ProcessList.forEach((item: Process) => {
            delete item.AreaMap.BackgroundPicture;
        });

        delete dto.SituationPlan?.BackgroundPicture;
        delete dto.SituationPlan?.Data;

        const jsonDto = JSON.stringify(dto);

        // return this.http.request(new HttpRequest('PUT', `${this.serviceUrl}/sync`, dto, this.generateHeaderWithEvents()))
        return this.http.put(`${this.serviceUrl}/sync`, jsonDto, this.generateHeader())
            .pipe(
                catchError(this.handleError<any>('sync')));
        // finalize(() => this.loadingTask.deactivateLoading()));
        // map(x => x));
    }

    exportIndexedDBAndLocalStorageAsJSON(jsonDB: any, jsonLocalStorage: any) {
        const formData: FormData = new FormData();

        formData.append('db', jsonDB);
        formData.append('localStorage', jsonLocalStorage);
        this.loadingTask.activateLoading();
        return this.http.post(`${this.serviceUrl}/dump`, formData, this.generateHeaderForFormData()).pipe(
            catchError(this.handleError<any>('exportIndexedDBAndLocalStorageAsJSON')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map(x => x));
    }
}